import { c as _c } from "react/compiler-runtime";
import { Checkbox } from "@flat-ui";
import { nounPluralize } from "@utils/data-display";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
/**
 * Checkbox to enable the user to create groups.
 * It is only shown if the selected role is a group manager
 * and the current user has the permission edit members.
 */
export function EnableGroupCreationCheckbox(t0) {
  const $ = _c(10);
  const {
    selectedRole,
    shouldCreateGroups,
    membersCount,
    setShouldCreateGroups
  } = t0;
  const {
    canEditMember
  } = useHasUserValidRoleCompanyLevel();
  if (selectedRole !== "COMPANY_MANAGER" || !canEditMember) {
    return null;
  }
  let t1;
  if ($[0] !== setShouldCreateGroups || $[1] !== shouldCreateGroups) {
    t1 = () => setShouldCreateGroups(!shouldCreateGroups);
    $[0] = setShouldCreateGroups;
    $[1] = shouldCreateGroups;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      mt: 1.25
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== membersCount) {
    t3 = nounPluralize({
      shouldShowCounter: false,
      counter: membersCount,
      word: "this user"
    });
    $[4] = membersCount;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `Enable ${t3} to create groups`;
  let t5;
  if ($[6] !== shouldCreateGroups || $[7] !== t1 || $[8] !== t4) {
    t5 = <Checkbox checked={shouldCreateGroups} onChange={t1} controlSx={t2} label={t4} />;
    $[6] = shouldCreateGroups;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}